const pushArticulosToArticulosSelected = ({
  articulosSelected,
  categorias,
}: $TSMigrationFixMe) => {
  const mergedArticulosSelected = { ...articulosSelected }

  categorias.forEach((categoria: $TSMigrationFixMe) => {
    const currentArticulos =
      articulosSelected[categoria.nombre]?.articulos || []
    const currentArticulosId = new Set(
      currentArticulos.map((articulo: $TSMigrationFixMe) => articulo.id)
    )

    const newArticulos = [...currentArticulos]

    categoria.articulos.forEach((articulo: $TSMigrationFixMe) => {
      if (!currentArticulosId.has(articulo.id)) {
        newArticulos.push(articulo)
      }
    })

    mergedArticulosSelected[categoria.nombre] = {
      ...mergedArticulosSelected?.[categoria.nombre],
      articulos: newArticulos,
    }
  })

  return mergedArticulosSelected
}

export default pushArticulosToArticulosSelected
